import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";
import {IPaginatedResponse, IService} from "maps-angular-components";

import {Funcao} from "../models/funcao";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";
import {handleError} from "src/app/shared/util/error-util";

@Injectable({
    providedIn: "root",
})
export class FuncaoApi implements IService<Funcao> {
    readonly url = "/v1/funcoes";

    constructor(private readonly httpclient: HttpClient) {
    }

    buscarCategorias(): Observable<string[]> {
        return this.httpclient.get<string[]>(`${this.url}/categorias`);
    }

    buscarFuncoes(categoria: string): Observable<Funcao[]> {
        if (categoria == null) {
            categoria = "";
        }
        const params = new HttpParams().append("categoria", categoria);
        return this.httpclient.get<Funcao[]>(`${this.url}`, {params});
    }

    buscarFuncao(nome: string): Observable<Funcao> {
        const params = new HttpParams().append("nome", nome);
        return this.httpclient
        .get<Funcao>(`${this.url}`, {params})
        .pipe(catchError(handleError));
    }

    autocomplete(parcial: string): Observable<Funcao> {
        const headers = new HttpHeaders({"Content-Type": "application/json"});
        const options = {headers};
        return this.httpclient
        .get<any>(
            `${this.url}/autocomplete?parcial=${encodeURIComponent(parcial)}`,
            options
        )
        .pipe(catchError(handleError));
    }

    parsePaginatedResponse(response): IPaginatedResponse<Funcao> {
        return {
            total: null,
            data: response.map((item) => new Funcao(item)),
        };
    }

    baixarModelosFuncoes(funcoes: Funcao[]): Observable<any> {
        const params = new HttpParams().append("funcoes", funcoes.map(f => f.nome).join(','));

        const headers = new HttpHeaders({"Content-Type": "application/json"});
        const options = {headers, params, responseType: 'arraybuffer' as 'json'};

        return this.httpclient
        .get<any>(
            `${this.url}/download-modelos`,
            options
        )
        .pipe(catchError(handleError));
    }
}
